import { fetchFileWithId } from "../services/httpService";

export const buildFormData = ({
  documentInfoId,
  entityType = "COMPANY",
  docPrintedId = null,
  docIssueDate = new Date().toISOString().split("T")[0],
  docCountry = "UAE",
  merchantId,
  uploadedFiles = [],
  entityId = null,
}) => {
  const formData = new FormData();

  formData.append("documentInfoId", documentInfoId);
  formData.append("entityType", entityType);
  formData.append("docPrintedId", docPrintedId);
  formData.append("docIssueDate", docIssueDate);
  formData.append("docCountry", docCountry);
  formData.append("merchantId", merchantId);

  // Add only new files (without docId)
  uploadedFiles
    .filter((file) => !file.docId && file.fileObject)
    .forEach((file) => {
      formData.append("files", file.fileObject);
    });

  if (entityId) {
    formData.append("entityId", entityId);
  }

  return formData;
};

// utils/filePreviewHelper.js
export const getFilePreview = async (file) => {
  try {
    // Case 1: Local file (uploaded but not saved on server)
    if (file?.fileObject) {
      const previewUrl = URL.createObjectURL(file.fileObject);
      return {
        success: true,
        preview: { url: previewUrl, name: file?.name || file?.fileName },
      };
    }

    // Case 2: File from server with docId / fileId
    if (file?.fileId) {
      const response = await fetchFileWithId(file.fileId);
      console.log(response, "response in getFilePreview");
      

      if (response) {
        const blob =
          response instanceof Blob ? response : await response.blob();
        const previewUrl = URL.createObjectURL(blob);

        return {
          success: true,
          preview: { url: previewUrl, name: file?.name || file?.fileName },
        };
      }
    }

    return { success: false, preview: null };
  } catch (error) {
    console.error("Error generating preview:", error);
    return { success: false, preview: null, error };
  }
};


// utils/fileUploadHelper.js
export const processFileUpload = ({
  event,
  existingFiles = [],
  validTypes = ["application/pdf", "image/png", "image/jpeg"],
  maxSizeMB = 15,
  maxFiles = 10,
}) => {
  const files = Array.from(event.target.files);

  const filtered = files.filter(
    (file) => validTypes.includes(file.type) && file.size <= maxSizeMB * 1024 * 1024
  );

  const rejectedCount = files.length - filtered.length;

  const newFiles = filtered.map((file) => ({
    name: file.name,
    docIssueDate: new Date().toISOString(),
    fileObject: file,
  }));

  const updatedFiles = [...existingFiles, ...newFiles].slice(0, maxFiles);

  return {
    updatedFiles,
    rejected: rejectedCount > 0,
  };
};

export const validateDate = (value) => {
  // setExpiryDate({uploadedDocumentId:e.target.value});
  const parts = value.split("-");

  let year = parts[0] || "";
  let month = parts[1] || "";
  let day = parts[2] || "";

  // Restrict year to 4 digits
  if (year.length > 4) {
    year = year.slice(0, 4);
  }

  const formattedValue = [year, month, day].filter(Boolean).join("-");
  return formattedValue;
};